/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media all and (-ms-high-contrast:none),(-ms-high-contrast:active){li.classOverride[_ngcontent-%COMP%]{min-height:23px}}"];
export { styles as styles };
